import axios from "axios";

export const wblCategoryService = {
  getWblCategories
};

function getWblCategories() {
  //debugger;
  return axios.get(`${process.env.VUE_APP_API_URL}/wbl-category/all`);
}
